import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84b32fba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "http://skolaplataforma-001-site1.site4future.com/resources/images/LOGO_PNG.png",
  alt: "logo-icon",
  class: "flex-shrink-0",
  style: {"width":"50px","height":"auto"}
}, null, -1))
const _hoisted_3 = { class: "school-title flex-grow-1 text-center m-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "sidebar-menu" }
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = ["data-bs-target", "aria-controls"]
const _hoisted_10 = { class: "title" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "accordion-body" }
const _hoisted_13 = { class: "sidebar-sub-menu-item" }
const _hoisted_14 = {
  key: 0,
  id: "menu",
  class: "sub-title sidebar-nav-item"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-uppercase fw-medium" }, "Menu", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Cerrar sesión", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
    'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
    { active: _ctx.stateStoreInstance.open },
  ]),
    id: "sidebar-area"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/Home",
        class: "d-flex align-items-center text-white text-decoration-none gap-2 w-100"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.curUserPayload?.EntityName), 1)
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("button", {
        class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0",
            key: index
          }, [
            _createElementVNode("a", {
              href: "#",
              class: "accordion-button rounded-0 shadow-none bg-transparent d-block",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#sidebarCollapse${index}`,
              "aria-expanded": "true",
              "aria-controls": `sidebarCollapse${index}`
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(item.Icon)
              }, null, 2),
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.Name), 1)
            ], 8, _hoisted_9),
            _createElementVNode("div", {
              id: `sidebarCollapse${index}`,
              class: "accordion-collapse collapse show",
              "data-bs-parent": "#sidebarNavAccordion"
            }, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRouter(item), (path, idx) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    class: "sidebar-sub-menu ps-0 mb-0 list-unstyled",
                    key: idx
                  }, [
                    _createElementVNode("li", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        to: `/${item.Path}${path.Path}`,
                        class: "sidebar-sub-menu-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(path.Name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ], 8, _hoisted_11),
            (item.Name === 'Dashboard')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("li", {
          class: "sidebar-nav-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
        }, [
          _createVNode(_component_router_link, {
            to: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout())),
            class: "sidebar-nav-link d-block"
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              _hoisted_18
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}